import { useSetRecoilState, useRecoilValue } from 'recoil';
import { myMuteAtom } from '../../State';
import { useLocalSessionId, useDaily } from '@daily-co/daily-react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import DataModel from '../Util/DataModel';
export default function MuteLocal() {
  //Daily系
  const callObject = useDaily();
  const localSessionId = useLocalSessionId();

  //Recoil系
  const myMuteState = useRecoilValue(myMuteAtom);

  //初期化の時
  useEffect(() => {
    saveData(myMuteState);
  }, [myMuteState]);

  //データベースに保存
  function saveData(status) {
    //データベースに保存
    if (callObject != null) {
      callObject
        .getMeetingSession()
        .then(async (session) => {
          try {
            //自分の情報をseessionに登録
            await DataModel.saveSessionToRoom(
              null, //ルームID
              session.meetingSession.id, //ルームのセッションID
              localSessionId, //ユーザーのテンポラリーユーザーID
              null, //顔
              null, //背景
              null, //顔認識 <isFaceTrackingå>
              null, //録画中
              status,
            );

            console.log('セッション保存完了');
          } catch (error) {
            console.log(error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  return false;
}
